module.exports = __webpack_public_path__ + "media/src/application/media/lk_bg/bg_2-39f56411538eadd9e49a468ac3742e8d.jpg";